import { Typography, Box, Tooltip } from '@mui/material';
import { useHatm } from '../../context/HatmContext';
import { ProgressBar } from '../../styles/hatm.styles';

export default function HatmProgress() {
  const { state, chosenJuzs } = useHatm();

  const totalJuzs = 30;
  const completedJuzs = Object.keys(state?.juzs || {}).length;
  const selectedJuzs = chosenJuzs.length;
  const progress = ((completedJuzs + selectedJuzs) / totalJuzs) * 100;

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Tooltip 
        title={`${completedJuzs} cüz alındı, ${selectedJuzs} cüz seçildi`}
        arrow
        placement="top"
      >
        <Box>
          <ProgressBar 
            variant="determinate" 
            value={progress} 
          />
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ mt: 1, textAlign: 'right', mr: 1 }}
          >
            {`%${Math.round(progress)} tamamlandı`}
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
} 